import { Slide } from '@/types/slide';

export interface ILesson {
    id: string;
    latestLessonVersion: {
        lessonName: string;
    };
    latestLessonDraft: {
        id: string;
        lessonName: string;
        dateUpdated: string;
        published: boolean;
        slides: Slide[];
    };
    shareWithPublic: boolean;
    sharesCount: number;
    shares: {
        id: string;
        user: {
            name: string;
            email: string;
        };
        email: string;
    }[];
    teacher: {
        id: string;
        user: {
            name: string;
            email: string;
        };
    };
    folder?: {
        id: string;
        sharesCount: number;
    };
}

export class Lesson implements ILesson {
    readonly id: string;
    readonly latestLessonVersion: {
        lessonName: string;
    };
    readonly latestLessonDraft: {
        id: string;
        lessonName: string;
        dateUpdated: string;
        published: boolean;
        slides: Slide[];
    };
    readonly shareWithPublic: boolean;
    readonly sharesCount: number;
    readonly teacher: {
        id: string;
        user: {
            name: string;
            email: string;
        };
    };
    readonly shares: {
        id: string;
        user: {
            name: string;
            email: string;
        };
        email: string;
    }[];
    readonly folder?: {
        id: string;
        sharesCount: number;
    };

    constructor(lesson: ILesson) {
        this.id = lesson.id;
        this.latestLessonVersion = lesson.latestLessonVersion;
        this.latestLessonDraft = lesson.latestLessonDraft;
        this.shareWithPublic = lesson.shareWithPublic;
        this.sharesCount = lesson.sharesCount;
        this.teacher = lesson.teacher;
        this.shares = lesson.shares;
        this.folder = lesson.folder;
    }

    isOwnedBy(profile: { id: string }) {
        return this.teacher?.id === profile.id;
    }

    isShared() {
        return (this.shares?.length ?? 0) > 0 || this.shareWithPublic || (this.folder?.sharesCount ?? 0) > 0;
    }
}
